export default `
  <link href='/snippets-style/footerLicense.css' rel='stylesheet' />
  <div class="ro-footer--license-container">
    <div class="ro-footer--license-inner">
      <div class="ro-footer--license__info">
        <a href="http://federbet.com" target="_blank" rel="noreferrer">
          <img src="/images/snippetsMedia/FB.png" alt="license" />
        </a>
        <a href="http://onjn.gov.ro/approved/" target="_blank" rel="noreferrer">
          <img src="/images/snippetsMedia/licences-onjn.png" alt="license" />
        </a>
        <a>
          <img src="/images/snippetsMedia/18.svg" alt=""/>
        </a>
      </div>
      <div class="ro-footer--license__payments">
        <div><img src="/images/snippetsMedia/securecode.svg" alt="securecode.svg"></div>
        <div><img src="/images/snippetsMedia/VerifiedByVisa.svg" alt="VerifiedByVisa.svg"></div>
        <div><img src="/images/snippetsMedia/Security_Standart_Council.svg" alt="Security_Standart_Council.svg"></div>
      </div>
      <div class="ro-footer--license__text">
        &copy;Favbet - Toate drepturile rezervate! Favbet functioneaza in baza licentei L1200662W001197 obtinuta in urma deciziei nr. 811 din data de 29.04.2020 emisa de catre Oficiul National pentru Jocuri de Noroc.
      </div>
    </div>
  </div>
`;
